import locale from "localization";

export const onboardPLBState = {
  form: {
    plbMaxDiscount: {
      label: locale.plbMaxDiscount,
      visible: false,
      value: "",
      initialValue: "",
      isDirty: false,
      validations: {
        isRequired: false,
      },
    },
    bankAccountName: {
      label: locale.bankAccountName,
      visible: true,
      value: "",
      initialValue: "",
      isDirty: false,
      maxLength: 75,
      validations: {
        isRequired: true,
      },
    },
    bankAccountNumber: {
      label: locale.bankAccountNumber,
      visible: true,
      value: "",
      initialValue: "",
      isDirty: false,
      maxLength: 75,
      validations: {
        isNumber: true,
        isRequired: true,
      },
    },
    nameOfBank: {
      label: locale.nameOfBank,
      visible: true,
      value: "",
      initialValue: "",
      isDirty: false,
      maxLength: 75,
      validations: {
        isRequired: true,
      },
    },
    settlementEmail: {
      label: locale.settlementEmail,
      visible: true,
      value: "",
      initialValue: "",
      isDirty: false,
      maxLength: 75,
      validations: {
        isEmail: true,
        isRequired: true,
      },
    },
    diesel: {
      label: "Diesel",
      value: "",
      initialValue: "",
      isDirty: false,
    },
    gas91: {
      label: "Gas 91",
      value: "",
      initialValue: "",
      isDirty: false,
    },
    gas95: {
      label: "Gas 95",
      value: "",
      initialValue: "",
      isDirty: false,
    },
    gas97: {
      label: "Gas 97",
      value: "",
      initialValue: "",
      isDirty: false,
    },
  },
};
